import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

// Positioning lives in FloatingActionButtons, which stacks this with
// WhatsAppButton — this component only renders the button itself.
const BuyerPortalButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to="/portal"
      data-testid="buyer-portal-button"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="group relative flex items-center"
    >
      {/* Hover label */}
      <span
        className={`absolute right-full mr-3 bg-navy text-gold px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-lg transition-all duration-300 ${
          isHovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        Buyer Portal
      </span>

      {/* Button */}
      <div
        className="relative w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-all duration-300 hover:scale-110"
        style={{
          background: "linear-gradient(135deg, #0B1629 0%, #1a2d4a 100%)",
          border: "2px solid #C5A059"
        }}
      >
        <Lock className="w-6 h-6 relative z-10 text-gold" strokeWidth={1.5} />
      </div>
    </Link>
  );
};

export default BuyerPortalButton;
